import { render } from "./SharePopup.vue?vue&type=template&id=1b3ae556&scoped=true"
import script from "./SharePopup.vue?vue&type=script&lang=js"
export * from "./SharePopup.vue?vue&type=script&lang=js"

import "./SharePopup.vue?vue&type=style&index=0&id=1b3ae556&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-1b3ae556"

export default script